// extracted by mini-css-extract-plugin
module.exports = {"comp":"TabSwiperB_comp__5OYZJ"};